import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setFactoryEfficiencyGrid = (state, { factoryEfficiencyGrid }) => {
  if (!factoryEfficiencyGrid) return state;
  return state.merge({ factoryEfficiencyGrid });
};

const setFactoryEfficiencyParams = (state, { params }) => {
  return state.merge({ params: params ?? {} });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const setToolCavityTable = (state, { toolCavityTable }) => {
  if (!toolCavityTable) return state;
  return state.merge({ toolCavityTable });
};
const setFactoryAutomationEquipments = (state, { automationEquipments }) => {
  return state.merge({ automationEquipments });
};
const setAutomationEquipmentConfiguration = (state, { equipmentConfiguration }) => {
  return state.merge({ equipmentConfiguration });
};
const setMovingAutomationLoader = (state, { movingAutomationLoader }) => {
  return state.merge({ movingAutomationLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_FACTORY_EFFICIENCY_PARAMS,
    actionFunction: setFactoryEfficiencyParams,
  },
  {
    actionType: ActionTypes.SET_FACTORY_EFFICIENCY_GRID,
    actionFunction: setFactoryEfficiencyGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_FACTORY_AUTOMATION_EQUIPMENTS,
    actionFunction: setFactoryAutomationEquipments,
  },
  {
    actionType: ActionTypes.SET_TOOL_CAVITY_TABLE,
    actionFunction: setToolCavityTable,
  },
  {
    actionType: ActionTypes.SET_AUTOMATION_EQUIPMENT_CONFIGURATION,
    actionFunction: setAutomationEquipmentConfiguration,
  },
  {
    actionType: ActionTypes.SET_MOVING_AUTOMATION_LOADER_STATUS,
    actionFunction: setMovingAutomationLoader,
  },
];
